import useSWR from 'swr';

import { MODELS_PATH } from '@api/paths';
import { IFunctionality } from '@models/IFunctionality';
import { fetcher } from '@utils/swr-utils';
import { IModel } from '@models/IModelBasic';

export default function useFunctionality(identity: IModel) {
  const { data, error, isLoading } = useSWR(
    // `${MODELS_PATH}/${identity.type}/${identity.module}/${identity.key}/${identity.version}`,
    `${MODELS_PATH}/${identity.aggregateId}`,
    fetcher
  );
  let functionality: IFunctionality | undefined = undefined;
  if (data && data.content) {
    functionality = JSON.parse(data.content);
  }

  return { functionality, isLoading, isError: Boolean(error) };
}
